<div class="user-comment">{{ userComment.comment }}</div>
<div class="user-comment-info">
    <div class="user-name">{{ userComment.userName }}</div>
    <div class="comment-date">{{ userComment.date | kendoDate: {datetime: 'short'} }}</div>
</div>